import { Autocomplete, Box, Button, Checkbox, FormControlLabel, Stack, TextField, Tooltip, Typography } from "@mui/material";
import React, { useState, useEffect } from "react";
import ToastMsg from "../../../Components/ToastMsg/ToastMsg";
import { CommonEditButton, CommonGridToolBarWithFilterText, DeletePopup } from "../../../Components/Common Components/CommonComponents";
import RestAPIService from "../../../Utility/Services/RestAPIService";
import Loader from '../../../Components/Loader'
import { CheckAccessFunc } from '../../../Components/CommonFunctions/CommonFunctions'
import { DataGrid } from '@mui/x-data-grid'
import { Serviceurls } from "../../../Utility/API/Serviceurls";
import { Colors } from "../../../Styles/Colors";
import CommonValidation from "../../../Components/CommonFunctions/CommonValidation";

const TherapistMaster = () => {
    const [formState, setFormState] = useState({
        employeeCode: "",
        employeeName: '',
        gender: "",
        grade: '',
        active: true,
    });
    const [message, setMessage] = useState({
        isErrorMsgText: '',
        successMsgText: '',
        isErrorMsg: false,
        successMsg: false,
    })
    const [gradeList, setGradeList] = useState([]);
    const [employeeList, setEmployeeList] = useState([]);
    const [TherpistData, setTherapistData] = useState([]);
    const [isActive, setIsActive] = useState(true);
    const [EditID, setEditID] = useState(null);
    const [isDelete, setisDelete] = useState(false);
    const [deletedID, setdeletedID] = useState(null);
    const [delIDs, setdelIDs] = useState([]);
    const [isloader, setisloader] = useState(false);
    const [CheckBoxList, setCheckBoxList] = useState([]);
    const [page, setpage] = useState(0);
    const [pageSize, setpageSize] = useState(10);
    let commonDisable = CheckAccessFunc("front_office", "Settings", "Service Master Configuration", "Surgery Master", "SubTab")?.editAccess

    useEffect(() => {
        getTherapistMasterData()
        getUserDetails()
        getGradeList()
    }, [])

    const getTherapistMasterData = () => {
        try {
            setisloader(true)
            RestAPIService.getAll(Serviceurls.AYURVEDA_THERAPIST_MASTER)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setisloader(false)
                        setTherapistData(response?.data?.data || [])
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }

    const getGradeList = () => {
        try {
            setisloader(true)
            RestAPIService.getAll(Serviceurls.AYURVEDA_THERAPIST_GRADES)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setisloader(false)
                        setGradeList(response?.data?.data || [])
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }

    const getUserDetails = () => {
        try {
            RestAPIService.getAll(Serviceurls.DAY_END_USER_DETAIL_GET + `?show_all=true`)
                .then((response) => {
                    if (response.data.status === 'success') {
                        let list = response.data.data
                        setEmployeeList(list)
                    }
                }).catch((error) => {
                    if (error?.response?.data?.status === 'fail') {
                        errorMessage(error.response.data.message)
                    } else {
                        errorMessage(error.message)
                    }
                })
        } catch (error) {
            errorMessage(error)
        }
    }

    const AddTherapistMaster = () => {
        try {
            if (!formState?.employeeName) {
                return errorMessage('Please Select Employee Name');
            }
            else if (CommonValidation.removeSpace(formState?.grade) == "") {
                return errorMessage('Please Enter Grade');
            }
            let data = {
                login_user: formState?.employeeName,
                grade: formState?.grade,
                is_active: isActive,
            }
            setisloader(true)
            let apiCall;
            if (EditID) {
                apiCall = RestAPIService.update(EditID, data, Serviceurls.AYURVEDA_THERAPIST_MASTER);
            } else {
                apiCall = RestAPIService.create(data, Serviceurls.AYURVEDA_THERAPIST_MASTER);
            }
            apiCall
                .then((response) => {
                    if (response.data.status === 'success') {
                        successMessage(response.data.message)
                        setFormState({
                            employeeCode: '',
                            employeeName: '',
                            gender: '',
                            grade: '',
                        });
                        setIsActive(true)
                        getTherapistMasterData()
                        setisloader(false)
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    }
                    else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }
    // Auto-fill Gender when employeeName changes
    // useEffect(() => {
    //     if (form.employeeName) {
    //         const selectedUser = userList.find((u) => u.name === form.employeeName);
    //         setForm((prev) => ({ ...prev, gender: selectedUser?.gender || "" }));
    //     }
    // }, [form.employeeName]);

    const errorMessage = (message) => {
        setMessage({
            ...message,
            isErrorMsg: true,
            isErrorMsgText: message,
            transmit: false,
            saveLoad: false
        })
    }

    const successMessage = (message) => {
        setMessage({
            ...message,
            successMsg: true,
            successMsgText: message,
        })
    }

    const msgClose = () => {
        setMessage({
            ...message,
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        })
    }

    // const handleChange = (e) => {
    //     const { name, value, type, checked } = e.target;
    //     setForm({
    //         ...form,
    //         [name]: type === "checkbox" ? checked : value,
    //     });
    // };

    const tableView = () => {

        const grpDelete = () => {
            setisDelete(true)
        }
        const gridToolBar = () => {
            return (
                <Box>
                    <CommonGridToolBarWithFilterText isDelete={delIDs?.length > 0} removeData={grpDelete.bind(this)} />
                </Box>

            )
        }

        const handleTableCheckbox = (id) => {
            let selectedIDs = new Set(id);
            setCheckBoxList(id)
            let selectedRows = TherpistData.filter((row) => selectedIDs.has(row.sno));
            let FinalData = []
            selectedRows.forEach((item) => {
                FinalData.push(item.id)
            })
            setdelIDs(FinalData)
        }

        TherpistData?.forEach((element, index) => element.sno = index + 1)
        const columns = [
            {
                field: 'sno', headerName: 'S.No', flex: 0.02, sortable: false,
                renderCell: (params) => (<Typography fontSize={'0.9vw'}>{params?.row?.sno}</Typography>)
            },
            {
                field: 'employee_code', headerName: 'Employee Code', flex: 0.15,
                renderCell: (params) => (<Box component={'div'}>{params?.row?.employee_code ? params?.row?.employee_code : '-'}</Box>)

            },
            {
                field: 'name', headerName: 'Employee Name', flex: 0.3,
                renderCell: (params) => (params.row.name ? params.row.name?.length > 32 ?
                    <Tooltip placement="top" title={params.row.name}><Typography fontSize={'0.9vw'}>{params.row.name?.slice(0, 30) + '...'}</Typography></Tooltip> :
                    <Typography fontSize={'0.9vw'}>{params.row.name}</Typography> : '-')

            },
            {
                field: 'gender', headerName: 'Gender', flex: 0.15,
                renderCell: (params) => (<Box component={'div'}>{params?.row?.gender ? params?.row?.gender : '-'}</Box>)

            },
            {
                field: 'grade_name', headerName: 'Grade', flex: 0.2,
                renderCell: (params) => (params.row.grade_name ? params.row.grade_name?.length > 32 ?
                    <Tooltip placement="top" title={params.row.grade_name}><Typography fontSize={'0.9vw'}>{params.row.grade_name?.slice(0, 30) + '...'}</Typography></Tooltip> :
                    <Typography fontSize={'0.9vw'}>{params.row.grade_name}</Typography> : '-')
            },
            {
                field: 'is_active', headerName: 'Status', flex: 0.1,
                renderCell: (params) => (<Box component={'div'}>{params?.row?.is_active == true ? "Active" : 'In Active'}</Box>)
            },
            ...(commonDisable ? [{
                field: 'action', headerName: 'Action', flex: 0.1, headerAlign: "center", align: "center",
                renderCell: (params) => (
                    <Stack direction="row" alignItems="center" spacing={4}>
                        <Stack direction="row" justifyContent="space-evenly" alignItems="center" spacing={1}>
                            <CommonEditButton size="1.5vw" onClick={() => {
                                setFormState({
                                    employeeCode: params.row.employee_code || '',
                                    employeeName: params.row.login_user || null,
                                    gender: params.row.gender || '',
                                    grade: params.row.grade_name || null,
                                });
                                setEditID(params.row.id);
                                setIsActive(params.row.is_active || false);
                            }} />
                        </Stack>
                    </Stack>)
            }] : [])
        ]
        return (
            <Box sx={{ height: '64vh' }}>
                <DataGrid
                    checkboxSelection={commonDisable ? true : false}
                    selectionModel={CheckBoxList}
                    onRowSelectionModelChange={(id) => handleTableCheckbox(id)}
                    rows={TherpistData}
                    columns={columns}
                    getRowId={(row) => row['sno']}
                    localeText={{
                        toolbarColumns: "",
                        toolbarDensity: "",
                        toolbarExport: "",
                        toolbarFilters: "",
                        toolbarExportPrint: ""
                    }}
                    components={{
                        Toolbar: gridToolBar,
                        NoRowsOverlay: () => (
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                {'No Records To Be Shown'}
                            </Box>
                        )
                    }}
                    pageSizeOptions={[10, 20, 30]}
                    pagination
                    paginationMode="client"
                    paginationModel={{
                        page: page,
                        pageSize: pageSize
                    }}
                    onPaginationModelChange={(model) => {
                        setpage(model.page)
                        setpageSize(model.pageSize)
                    }}
                    getRowClassName={(params) => params.row.is_active === false ? 'gray-row' : ''}
                    sx={{
                        "& .gray-row .MuiDataGrid-cell": {
                            backgroundColor: "#e8e7e7 !important",
                            color: "black !important",
                        },
                        "& .gray-row .MuiDataGrid-cell[data-field='action'], & .gray-row:has(.MuiDataGrid-cell--checkbox)": {
                            backgroundColor: "white !important",
                            color: "black !important",
                        },
                        "& .gray-row .MuiDataGrid-cell:nth-child(1)": {
                            backgroundColor: "white !important",
                        }
                    }}
                    headerHeight={40}
                    density='compact'
                    disableRowSelectionOnClick
                    loading={isloader}
                />
            </Box>
        )
    }

    const deleteTherapistMaster = () => {
        try {
            let ID = deletedID ? [deletedID] : (delIDs || [])
            RestAPIService.delete(Serviceurls.AYURVEDA_THERAPIST_MASTER + `?ids=${ID}`)
                .then((response) => {
                    if (response.data.status === 'success') {
                        successMessage(response.data.message)
                        getTherapistMasterData()
                        setdelIDs([]);
                        setCheckBoxList([]);
                        setdeletedID(null);
                        setisDelete(false)
                    }
                }).catch(e => {
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            errorMessage(e.message)
        }
    }
    const PopupClose = () => {
        setisDelete(false);
        setdeletedID(null)
    }

    const textBox = (label, name, val, width, disable, list) => {
        return (
            <Box>
                {name === 'employeeName' ?
                    <Autocomplete
                        size={'small'}
                        options={list || []}
                        name={name}
                        getOptionLabel={(option) => (option.login_fname ?? option.user_name) + (option.login_lname ?? "")}
                        value={list?.find((emp) => emp.id === val) || null}
                        sx={{ width: width, marginRight: '1vw' }}
                        onChange={(event, newValue) => {
                            setFormState({ ...formState, [name]: newValue?.id || "" });
                        }}
                        renderInput={(params) => <TextField {...params} label={label} />}
                    />
                    :
                    <TextField
                        size='small'
                        name={name}
                        value={val}
                        disabled={disable}
                        sx={{ width: width, marginRight: '1vw' }}
                        label={label}
                        variant="outlined"
                    />
                }
            </Box>
        )
    }

    return (
        <Box component={'div'} sx={{ height: '79.5vh', width: '94vw', backgroundColor: Colors.Background, padding: '.5vw' }}>
            <Box component={'div'} sx={{ height: '13vh', width: '93vw', alignContent: 'center', backgroundColor: "white", padding: "0.5vw" }}>
                <Box component={'div'} sx={{ display: 'flex', flexDirection: 'row' }}>
                    {textBox("Employee Code", 'employeeCode', formState?.employeeCode, '15vw', true)}
                    {textBox("Therapist Name *", 'employeeName', formState?.employeeName, '15vw', EditID ? true : false, employeeList)}
                    {textBox("Gender", 'gender', formState?.gender, '15vw', true,)}
                    <Autocomplete
                        freeSolo
                        disableClearable
                        size="small"
                        sx={{ width: "15vw" }}
                        options={gradeList || []}
                        getOptionLabel={(option) => {
                            if (typeof option === "string") return option;
                            if (option?.name) return option.name;
                            return "";
                        }}
                        value={
                            gradeList.find((g) => g.id === formState.grade) ||
                            formState.grade || ""
                        }
                        onChange={(event, newValue) => {
                            if (typeof newValue === "string") {
                                // typed text saved as string
                                setFormState((prev) => ({
                                    ...prev,
                                    grade: newValue,
                                }));
                            } else {
                                // picked from list → save id
                                setFormState((prev) => ({
                                    ...prev,
                                    grade: newValue?.id || "",
                                }));
                            }
                        }}
                        onInputChange={(event, newInputValue) => {
                            if (event?.type === "change") {
                                setFormState((prev) => ({
                                    ...prev,
                                    grade: newInputValue,
                                }));
                            }
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Grade *"
                                autoComplete="off"
                                size="small"
                                inputProps={{
                                    ...params.inputProps,
                                    maxLength: 50,
                                }}
                            />
                        )}
                    />
                </Box>
                <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", marginTop: "0.5vw" }}>
                    <Box sx={{ display: 'flex' }}>
                        <FormControlLabel control={<Checkbox checked={isActive} onChange={(e) => { setIsActive(e.target.checked) }} disabled={!EditID} size='small' />} label={"Active"} />
                    </Box>
                    <Box component={'div'} sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', }}>
                        <Button size='small' variant='outlined' sx={{ textTransform: 'capitalize', width: '7vw', marginRight: "0.5vw" }}
                            disabled={!commonDisable}
                            onClick={() => {
                                setFormState({
                                    employeeName: '',
                                    employeeCode: '',
                                    gender: '',
                                    grade: '',
                                });
                                setIsActive(true)
                                setEditID(null)
                            }}>Clear</Button>
                        <Button size='small' variant='contained' disabled={!commonDisable} sx={{ textTransform: 'capitalize', width: '7vw' }}
                            onClick={() => { AddTherapistMaster() }}>{EditID ? 'Update' : 'Save'}</Button>
                    </Box>
                </Box>
            </Box>
            <Box component={'div'} sx={{ height: '64vh', width: '93vw', marginTop: '.5vw', backgroundColor: 'white', }}>
                {tableView()}
            </Box>
            {message.isErrorMsg ?
                <ToastMsg
                    severity={'error'}
                    msg={message.isErrorMsgText}
                    msgPop={msgClose.bind(this)}
                />
                : null}
            {message.successMsg ?
                <ToastMsg
                    severity={'success'}
                    msg={message.successMsgText}
                    msgPop={msgClose.bind(this)}
                />
                : null}
            {isDelete ?
                <DeletePopup
                    DeletTitle={`This action will affect in Thearapy Mapping as well, Are you sure you want to delete this item ?`}
                    DeleteNotify={"This action cannot be undone."}
                    deleteAlertPopupClose={PopupClose.bind(this)}
                    removeData={deleteTherapistMaster.bind(this)}
                    ButtonText={'Yes'}
                />
                : null}
            <Loader loaderOpen={isloader} />
        </Box>
    );
};

export default TherapistMaster;
